export type Buyer = { name: string; country: string; minutesAgo: number };

export const buyers: Buyer[] = [
  { name: "Valentina R.", country: "Mexico", minutesAgo: 2 },
  { name: "Camila G.", country: "Colombia", minutesAgo: 4 },
  { name: "Sofía M.", country: "Argentina", minutesAgo: 1 },
  { name: "Mateo L.", country: "Chile", minutesAgo: 6 },
  { name: "Lucía F.", country: "Spain", minutesAgo: 3 },
  { name: "Diego A.", country: "Peru", minutesAgo: 5 },
  { name: "Isabella C.", country: "Ecuador", minutesAgo: 2 },
  { name: "Andrés P.", country: "Venezuela", minutesAgo: 8 },
  { name: "Gabriela S.", country: "Guatemala", minutesAgo: 3 },
  { name: "Martina V.", country: "Uruguay", minutesAgo: 7 },
  { name: "Carlos J.", country: "Dominican Republic", minutesAgo: 1 },
  { name: "Paula H.", country: "Costa Rica", minutesAgo: 4 },
  { name: "Daniela O.", country: "Puerto Rico", minutesAgo: 6 },
  { name: "Fernanda T.", country: "Bolivia", minutesAgo: 2 },
  { name: "José N.", country: "Paraguay", minutesAgo: 5 },
  { name: "Mariana E.", country: "Panama", minutesAgo: 3 },
];
